import cx from 'classnames'

import Shared from './CompanyLogo.module.scss'
import { ReactComponent as RedBlazeLogo } from './blazeLogoRed.svg'
import { ReactComponent as RedBlazeLogoSmall } from './blazeLogoRedSmall.svg'
import { ReactComponent as BlazeLogoBig } from './blazeLogoBig.svg'

interface ClassProps {
  wrapper?: string
  logo?: string
}

interface Props {
  styles?: ClassProps
  verticalCenter?: boolean
  darkMode?: boolean
  small?: boolean
  red?: boolean
}

const CompanyLogo = ({ styles, verticalCenter, small, red }: Props) => {
  let Logo

  if (red) {
    if (small) {
      Logo = RedBlazeLogoSmall
    } else {
      Logo = RedBlazeLogo
    }
  } else {
    Logo = BlazeLogoBig
  }

  return (
    <div className={cx(Shared.logoAndCompanyName, styles?.wrapper, { [Shared.isBlaze]: true })}>
      {verticalCenter && <span className={Shared.verticalCenter} />}
      <Logo className={cx(styles?.logo, { [Shared.dark]: false })} data-testid="almanac-logo" />
    </div>
  )
}

export default CompanyLogo
